module.exports = __webpack_public_path__ + "static/img/rz(8).c817760c.jpg";